import { useMemo } from 'react';
import getHeightOfDate from '../../helpers/getHeightOfDate';

export default function useClockLineStyle(clock:Date) {
    return useMemo(() => ({ top: `${getHeightOfDate(clock)}px` }), [clock]);
}
